module.exports = __webpack_public_path__ + "img/1.d2c1d4de.png";